/**
 * This function will put ad videos to specific position inside feed videos
 */
export function putAdsToPositionInFeed(props) {
    const { videos, adVideos, positions } = props;
    const sortedPositions = [...positions];
    sortedPositions.sort();
    const stitchedVideos = [...videos];
    for (let index = 0; index < sortedPositions.length; index++) {
        const position = sortedPositions[index];
        if (!adVideos[index]) {
            break;
        }
        else if (adVideos[+index + 1] && !positions[+index + 1]) {
            const restOfAdVideos = adVideos.slice(+index);
            stitchedVideos.splice(+position, 0, ...restOfAdVideos);
        }
        else {
            stitchedVideos.splice(+position, 0, adVideos[index]);
        }
    }
    return stitchedVideos;
}
